export default "__VITE_PUBLIC_ASSET__05d09fa3__"